// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Loader_spinnerContainer__1Jf50","imgContainer":"Loader_imgContainer__3s6AQ","loadingBar":"Loader_loadingBar__3IXYb"};